import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { Maestro_Consultas } from '../../models/generic/Maestro_Consultas';
import { Maestro_ConsultasTipos } from 'src/app/models/generic/Maestro_ConsultasTipos';
import { Maestros_ConsultasTiposService } from 'src/app/services/maestros_consultastipos.service';
import { Maestros_ConsultasService } from 'src/app/services/maestros_consultas.service';
import { Maestro_ConsultasAplicaciones } from 'src/app/models/generic/Maestro_ConsultasAplicaciones';
import { Maestro_ConsultasRoles } from '../../models/generic/Maestro_ConsultasRoles';
import { Maestro_ConsultasUsuarios } from '../../models/generic/Maestro_ConsultasUsuarios';
import { Maestro_ConsultasTiposParametros } from 'src/app/models/generic/Maestro_ConsultasTiposParametros';
import { Maestros_ConsultasTiposParametrosService } from 'src/app/services/maestros_consultastiposparametros.service';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { Maestro_ConsultasParametros } from 'src/app/models/generic/Maestro_ConsultasParametros';
import { Maestro_Consultas_Actualizacion } from '../../models/generic/Maestro_Consultas_Actualizacion';
import { AdicionarItemsListaComponent } from '../adicionar-items-lista/adicionar-items-lista.component';

@Component({
  selector: 'maestros-consultas-editar',
  templateUrl: './maestros-consultas-editar.component.html',
  styleUrls: ['./maestros-consultas-editar.component.scss']
})
export class MaestrosConsultasEditarComponent implements OnInit{
  
  form: FormGroup;
  tituloForma: string = 'Registro de reporte';
  tituloBoton: string = 'Registrar reporte';
  mostrarCargando: boolean = false;
  listaDatosAplicaciones: Maestro_ConsultasAplicaciones[] = [];
  listaDatosRoles: Maestro_ConsultasRoles[] = [];
  listaDatosUsuarios: Maestro_ConsultasUsuarios[] = [];  
  codigoAccion: string = '';
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('appvaloresposiblesmodal', {static: false}) _appvaloresposiblesmodal: AdicionarItemsListaComponent;
  listaTipos: Maestro_ConsultasTipos[] = [];
  listaTiposParametros: Maestro_ConsultasTiposParametros[] = [];
  listaEstado: Maestro_EstadoActualizar[] = [];
  listaRequerido: Maestro_EstadoActualizar[] = [];
  listaTipoExportacion: Maestro_EstadoActualizar[] = [];
  idTipoParametroSeleccion: number = 0;
  idTipoParametroConsulta: number = 0;
  idTabSeleccionado: number = 0;

  detalleSeleccionado: number;
  formParametros: FormGroup;
  editarRegistroParametro: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSourceParametros: MatTableDataSource<Maestro_ConsultasParametros>;
  columnasEncabezadoParametro: string[] = ['id', 'nombreParametro', 'descripcionParametro', 'tipoParametro', 'orden', 'acciones'];
  listaDatosParametros: Maestro_ConsultasParametros[] = [];
  listaDatosParametrosEliminar: Maestro_ConsultasParametros[] = [];
  parametrosPrincipal: Maestro_Consultas;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_ConsultasService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public consultasTiposService: Maestros_ConsultasTiposService,
    public consultasTiposParametrosService: Maestros_ConsultasTiposParametrosService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.ConsultarTipos();
    this.ConsultarTiposParametros();
    this.listaEstado = [];
    this.listaRequerido = [];
    this.listaTipoExportacion = [];

    this.listaEstado.push({ seleccionado: true, descripcion: 'Activo' });
    this.listaEstado.push({ seleccionado: false, descripcion: 'Inactivo' });

    this.listaRequerido.push({ seleccionado: true, descripcion: 'Si' });
    this.listaRequerido.push({ seleccionado: false, descripcion: 'No' });

    this.listaTipoExportacion.push({ seleccionado: false, descripcion: 'EXCEL' });
    this.listaTipoExportacion.push({ seleccionado: false, descripcion: 'PLANO' });
    
    this.listaDatosParametrosEliminar = [];
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    
    if (this.utilitariosService.VerificarContieneDatos(this.menuService.ParametrosAdicionales)) {
      this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);
      this.parametrosPrincipal.aplicacionesSeleccionada = [];
      this.parametrosPrincipal.rolesSeleccionados = [];
      this.parametrosPrincipal.usuariosSeleccionados = [];

      // console.log('setea valor', this.parametrosPrincipal);
      this.form.setValue(this.parametrosPrincipal);
      
      this.tituloForma = 'Edición de reporte';
      this.tituloBoton = 'Editar reporte';
    } else {
      this.tituloForma = 'Registro de reporte';
      this.tituloBoton = 'Registrar reporte';
      this.parametrosPrincipal = new Maestro_Consultas();
      this.parametrosPrincipal.id = 0;
      this.parametrosPrincipal.tipoExportacion = 'EXCEL';
      this.listaDatosParametros = [];
      this.recargarListaParametros();
    }
    this.ConsultarRegistrosAplicaciones();
    this.ConsultarRegistrosRoles();
    this.ConsultarRegistrosUsuarios();
    this.ConsultarRegistrosParametros();
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      id: [0],
      nombreConsulta: ['', [Validators.required, Validators.maxLength(100)]],
      descripcionConsulta: ['', [Validators.required, Validators.maxLength(500)]],
      idTipoConsulta: [0, [Validators.required]],
      descripcionTipoConsulta: [''],
      queryEjecutar: ['', [Validators.required]],
      activo: [true],
      aplicacionesSeleccionada: [[], [Validators.required]],
      rolesSeleccionados: [[]],
      usuariosSeleccionados: [[]],
      columnaTotalizar: ['', [Validators.maxLength(100)]],
      tipoExportacion: ['', [Validators.required]],
      extensionArchivoPlano: [''],
      separadorArchivoPlano: [''],
      queryExportar: [''],
    });

    this.form.get('tipoExportacion').valueChanges.subscribe((valorNuevo) => {
      this.EstablecerDatosAdicionalesRequeridos();
    });

    this.IniciarFormularioParametro();
  }
  EstablecerDatosAdicionalesRequeridos() {
    let validatorsRequerido = [];
    
    if (this.form.get('tipoExportacion').value === 'PLANO') {
      validatorsRequerido.push(Validators.required);
    }

    this.form.get('extensionArchivoPlano').setValidators(validatorsRequerido);
    this.form.get('extensionArchivoPlano').updateValueAndValidity();
    this.form.get('queryExportar').setValidators(validatorsRequerido);
    this.form.get('queryExportar').updateValueAndValidity();
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MaestrosConsultasComponent');
  }
  Guardar() {
    if (this.form.valid) {
      this.codigoAccion = 'guardar';
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ActualizarRegistro();
      } else {
        this.EliminarRegistroParametro();
      }
    }
  }
  ActualizarRegistro() {
    this.mostrarCargando = true;
    
    let listaAplicacionesSeleccionados = this.form.get('aplicacionesSeleccionada').value;
    let listaRolesSeleccionados = this.form.get('rolesSeleccionados').value;
    let listaUsuariosSeleccionados = this.form.get('usuariosSeleccionados').value;

    for (let index = 0; index < this.listaDatosAplicaciones.length; index++) {
      if (listaAplicacionesSeleccionados.filter(x => x === this.listaDatosAplicaciones[index].idAplicacion).length > 0) {
        this.listaDatosAplicaciones[index].seleccionado = true;
      } else {
        this.listaDatosAplicaciones[index].seleccionado = false;
      }
    }

    for (let index = 0; index < this.listaDatosRoles.length; index++) {
      if (listaRolesSeleccionados.filter(x => x === this.listaDatosRoles[index].idRol).length > 0) {
        this.listaDatosRoles[index].seleccionado = true;
      } else {
        this.listaDatosRoles[index].seleccionado = false;
      }
    }

    for (let index = 0; index < this.listaDatosUsuarios.length; index++) {
      if (listaUsuariosSeleccionados.filter(x => x === this.listaDatosUsuarios[index].idUsuario).length > 0) {
        this.listaDatosUsuarios[index].seleccionado = true;
      } else {
        this.listaDatosUsuarios[index].seleccionado = false;
      }
    }
    
    let parametrosActualizacion: Maestro_Consultas_Actualizacion = new Maestro_Consultas_Actualizacion();
    parametrosActualizacion.principal = new Maestro_Consultas();
    parametrosActualizacion.principal.id = this.form.get('id').value;
    parametrosActualizacion.principal.nombreConsulta = this.form.get('nombreConsulta').value;
    parametrosActualizacion.principal.descripcionConsulta = this.form.get('descripcionConsulta').value;
    parametrosActualizacion.principal.idTipoConsulta = this.form.get('idTipoConsulta').value;
    parametrosActualizacion.principal.descripcionTipoConsulta = this.form.get('descripcionTipoConsulta').value;
    parametrosActualizacion.principal.queryEjecutar = this.form.get('queryEjecutar').value;
    parametrosActualizacion.principal.activo = this.form.get('activo').value;
    parametrosActualizacion.principal.columnaTotalizar = this.form.get('columnaTotalizar').value;
    parametrosActualizacion.principal.tipoExportacion = this.form.get('tipoExportacion').value;
    parametrosActualizacion.principal.extensionArchivoPlano = this.form.get('extensionArchivoPlano').value;
    parametrosActualizacion.principal.separadorArchivoPlano = this.form.get('separadorArchivoPlano').value;
    parametrosActualizacion.principal.queryExportar = this.form.get('queryExportar').value;
    parametrosActualizacion.listaAplicaciones = this.listaDatosAplicaciones;
    parametrosActualizacion.listaRoles = this.listaDatosRoles;
    parametrosActualizacion.listaUsuarios = this.listaDatosUsuarios;
    parametrosActualizacion.listaParametros = this.listaDatosParametros;
    parametrosActualizacion.listaParametrosEliminar = this.listaDatosParametrosEliminar;

    this.datosServices.Actualizar(parametrosActualizacion)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else {
                this.menuService.CambiarComponenteActivo('MaestrosConsultasComponent');
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarTipos() {
    this.mostrarCargando = true;
    let parametroConsulta = this.fb.group({
      filtro: ['']
    });
    this.consultasTiposService.Consultar(parametroConsulta.value)
            .subscribe((resp: Maestro_ConsultasTipos[]) =>{
              this.listaTipos = resp;

              this.mostrarCargando = false;
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarTiposParametros() {
    this.mostrarCargando = true;
    let parametroConsulta = this.fb.group({
      filtro: ['']
    });
    this.consultasTiposParametrosService.Consultar(parametroConsulta.value)
            .subscribe((resp: Maestro_ConsultasTiposParametros[]) =>{
              this.listaTiposParametros = resp;
              for (let index = 0; index < this.listaTiposParametros.length; index++) {
                if (this.listaTiposParametros[index].tipoParametro === 'LISTA') {
                  this.idTipoParametroSeleccion = this.listaTiposParametros[index].id;
                } else if (this.listaTiposParametros[index].tipoParametro === 'LISTAAPLICACION') {
                  this.idTipoParametroConsulta = this.listaTiposParametros[index].id;
                }
              }
              this.mostrarCargando = false;
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarRegistrosAplicaciones() {
    this.mostrarCargando = true;
    this.datosServices.Aplicaciones_Consultar(this.parametrosPrincipal.id)
              .subscribe((resp: Maestro_ConsultasAplicaciones[]) =>{
                this.mostrarCargando = false;
                this.listaDatosAplicaciones = resp;
                this.parametrosPrincipal.aplicacionesSeleccionada = [];
                
                for (let index = 0; index < this.listaDatosAplicaciones.length; index++) {
                  if (this.listaDatosAplicaciones[index].seleccionado) {
                    this.parametrosPrincipal.aplicacionesSeleccionada.push(this.listaDatosAplicaciones[index].idAplicacion);
                  }
                }
                this.form.get('aplicacionesSeleccionada').setValue(this.parametrosPrincipal.aplicacionesSeleccionada);
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistrosRoles() {
    this.mostrarCargando = true;
    this.datosServices.Roles_Consultar(this.parametrosPrincipal.id)
              .subscribe((resp: Maestro_ConsultasRoles[]) =>{
                this.mostrarCargando = false;
                this.listaDatosRoles = resp;
                this.parametrosPrincipal.rolesSeleccionados = [];
                
                for (let index = 0; index < this.listaDatosRoles.length; index++) {
                  if (this.listaDatosRoles[index].seleccionado) {
                    this.parametrosPrincipal.rolesSeleccionados.push(this.listaDatosRoles[index].idRol);
                  }
                }
                this.form.get('rolesSeleccionados').setValue(this.parametrosPrincipal.rolesSeleccionados);
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistrosUsuarios() {
    this.mostrarCargando = true;
    this.datosServices.Usuarios_Consultar(this.parametrosPrincipal.id)
              .subscribe((resp: Maestro_ConsultasUsuarios[]) =>{
                this.mostrarCargando = false;
                this.listaDatosUsuarios = resp;
                this.parametrosPrincipal.usuariosSeleccionados = [];
                
                for (let index = 0; index < this.listaDatosUsuarios.length; index++) {
                  if (this.listaDatosUsuarios[index].seleccionado) {
                    this.parametrosPrincipal.usuariosSeleccionados.push(this.listaDatosUsuarios[index].idUsuario);
                  }
                }
                this.form.get('usuariosSeleccionados').setValue(this.parametrosPrincipal.usuariosSeleccionados);
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarRegistrosParametros() {
    this.mostrarCargando = true;
    this.datosServices.Parametros_Consultar(this.parametrosPrincipal.id)
              .subscribe((resp: Maestro_ConsultasParametros[]) =>{
                this.mostrarCargando = false;
                this.listaDatosParametros = resp;
                this.recargarListaParametros();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  SeleccionoValoresPosibles(valoresPosibles: string) {
    this.formParametros.get('valoresPosibles').setValue(valoresPosibles);
  }
  tabSeleccionado(item: any) {
    this.idTabSeleccionado = item.index;    
  }

  IniciarFormularioParametro() {
    this.formParametros = this.fb.group({
      id: [0],
      nombreParametro: ['', [Validators.required, Validators.maxLength(100)]],
      descripcionParametro: ['', [Validators.required, Validators.maxLength(500)]],
      idTipoParametro: [0, [Validators.required]],
      tipoParametro: [''],
      requerido: [true],
      valoresPosibles: [''],
      orden: [0],
      filtroPrincipal: [true],
      valorDefecto: [''],
      mostrarParametro: [true],
    });
  }
  recargarListaParametros() {
    this.dataSourceParametros = new MatTableDataSource(this.listaDatosParametros);
    this.dataSourceParametros.paginator = this.paginator;
    this.dataSourceParametros.sort = this.sort;
  }
  NuevoParametro() {
    this.editarRegistroParametro = true;
    this.IniciarFormularioParametro();
    this.formParametros.get('id').setValue((this.listaDatosParametros.length + 1) * -1);
  }
  EditarParametro(parametroEditar: Maestro_ConsultasParametros) {
    this.editarRegistroParametro = true;
    this.formParametros.setValue(parametroEditar);
  }
  EliminarParametro(parametroEditar: Maestro_ConsultasParametros) {
    this.detalleSeleccionado = parametroEditar.id;
    this.codigoAccion = 'eliminarParametro';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarParametro() {
    if (this.formParametros.valid) {
      this.editarRegistroParametro = false;
      let tipoParametro = this.listaTiposParametros.filter(x => x.id === this.formParametros.get('idTipoParametro').value);
      this.formParametros.get('tipoParametro').setValue(tipoParametro[0].tipoParametro);
      console.log(this.listaDatosParametros, this.formParametros.value);
      if (this.listaDatosParametros.filter(x => x.id === this.formParametros.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosParametros.filter(x => x.id === this.formParametros.get('id').value)[0];
        parametroActualizar.nombreParametro = this.formParametros.get('nombreParametro').value;
        parametroActualizar.descripcionParametro = this.formParametros.get('descripcionParametro').value;
        parametroActualizar.idTipoParametro = this.formParametros.get('idTipoParametro').value;
        parametroActualizar.tipoParametro = this.formParametros.get('tipoParametro').value;
        parametroActualizar.requerido = this.formParametros.get('requerido').value;
        parametroActualizar.valoresPosibles = this.formParametros.get('valoresPosibles').value;
        parametroActualizar.orden = this.formParametros.get('orden').value;
        parametroActualizar.filtroPrincipal = this.formParametros.get('filtroPrincipal').value;
        parametroActualizar.mostrarParametro = this.formParametros.get('mostrarParametro').value;
        parametroActualizar.valorDefecto = this.formParametros.get('valorDefecto').value;
      } else {
        this.listaDatosParametros.push(this.formParametros.value);
      }
      
      this.recargarListaParametros();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formParametros);
    }
  }
  CancelarEditarParametro() {
    this.editarRegistroParametro = false;
  }
  EliminarRegistroParametro() {
    if (this.detalleSeleccionado > 0) {
      this.listaDatosParametrosEliminar.push(this.listaDatosParametros.filter(x => x.id === this.detalleSeleccionado)[0]);
    }
    let listaNueva: Maestro_ConsultasParametros[] = [];
    for (let index = 0; index < this.listaDatosParametros.length; index++) {
      if (this.listaDatosParametros[index].id !== this.detalleSeleccionado) {
        listaNueva.push(this.listaDatosParametros[index]);
      }
    }
    this.listaDatosParametros = listaNueva;
    this.recargarListaParametros();
  }
  EditarParametroValoresPosibles() {
    this._appvaloresposiblesmodal.MostrarEdicionItemsLista(this.formParametros.get('valoresPosibles').value);
  }
}
